export default {
  about:{
    title: 'About us',
    description: 'We are a high-level consultant firm with an extensive experience in business, Audit, taxes, finance, and legal matters in the business area.',
    subdescription: 'We provide professional advice to promote successful businesses and solving problems in a creative and different way; from a young and innovative point of view, we provide strategies suited to the context of today&#39;s globalized market.',
    conformed: 'Our staff and board of directors',
  },
  filtereditem: {
    0: {
      title: 'Partners',
      items: [
        {name: '- Partner director'},
        {name: '- Consulting, Audit and Tax Partner'},
        {name: '- Managing partner'},
        {name: '- Legal Partner'},
        {name: '- Partner Taxes and Transfer Prices Mexico and Region'},
      ]
    },
    1: {
      title: 'Managers',
      items: [
        {name:'- audit'},
        {name:'- Consulting'},
        {name:'- Taxes'},
        {name:'- Technology and Systems'},
      ]
    },
    2: {
      title: 'Staff',
      items: [
        {name:'- audit'},
        {name:'- Legal'},
        {name:'- Consulting, technology and systems'},
        {name:'- Taxes'}
      ]
    },
    3: {
      title: 'Administration',
      items: [
        {name:'- Administrative and Financial Manager'},
        {name:'- Human resources manager'},
      ]
    }
  },
  partners:
  {
    title: 'Our Partners',
    list:[
      {
        name:'Lic. Jorge A. Román García.',
        dep: 'CEO.',
        description: 'Jorge Román García is an Auditor and Consultant with more than 40 years of professional experience. He worked as an audit manager at the firm Peat Marwick & Mitchel better known as KPMG, where he spent twelve years and where he was appointed as the instructor for Latin America for KPMG international.',
        description2: 'He is the founder of Román y Román Consultores. To the present date, he is responsible of the quality guidelines of the firm, his extensive experience makes the high parameters of professionalism, principles and values very specific to his clients and his team.',
        description3: 'Our CEO has a wide experience in commercial, real estate, textile, service and financial business, agribusiness, coffee industry, insurance companies, and non-profit organizations, among others.'
      },
      {
        name:'Licda. Doris Román de Amado.',
        dep: 'Administration Manager (Partner).',
        description: "Doris Román de Amado has more than 20 years of professional experience in Sworn Translation (English-Spanish), she is a graduate of the Women's Institute of Higher Studies (IFES, Instituto Femenino de Estudios Superiores), certified before the Ministry of Education and registered in the American and Canadian Embassies in Guatemala.",
        description2: 'Her career has been developed at the firm Román & Román Consultores.',
        description3: 'She has extensive experience in English-Spanish, Spanish-English translations, focused on manuals, brochures, legal documents, reports, among others.'
      },
      {
        name:'Lic. Jorge Román Pineda.',
        dep: 'Managing Partner',
        description: 'Jorge Román Pineda has 18 years of professional experience as an Auditor and Consultant, starting his professional career at the firm Román & Román Consultores.',
        description2: 'His professional training includes providing consulting and training services to corporations and industries about the fraud risk management, its prevention and detection, also meeting with different insurance companies to provide service to their clients due to claims of this nature.',
        description3: 'His proficiency is focused on financial business, insurance, textile, agro-commercial, non-profit and service companies.',
      },
      // {
      //   name:'Lic. Ernesto Figueroa.',
      //   dep: 'Partner in Transfer Pricing.',
      //   description: 'Ernesto Figueroa is a Public Accountant and Lawyer, has 12 years of professional experience in the Republic of the United Mexican States, developing professionally in the firm RSM (Bogarin y Asociados, Mexico Guadalajara)then forms its own consultancy firm and has been in commercial partnership with Román & Román Consultores since 2014.',
      //   description2: '',
      //   description3: 'Ernesto is active in advising and creating commercial companies, in addition to providing the Transfer Pricing Service.'
      // },
    ]
  }
}



// WEBPACK FOOTER //
// ./src/text/en/about.js